import { NamedResource } from '@core/resources/resource';
import { DESTINATION_ICONS, Destination } from '../destination';
import { LANGUAGE_I18N_2_THEME } from '../language.maps';

type Source = 'olfeo' | 'ut1';
export const SOURCE: {[key: string]: Source} = {
  olfeo: 'olfeo',
  ut1: 'ut1'
};

export interface CategoryLanguage {
  language: string;
  label: string;
  description: string;
  subtitle: string;
}

/**
 * Interface describing a Category object returned by the API
 */
export interface CategoryIO {
  id: string;
  source: string;
  languages: CategoryLanguage[];
}

export function isCategory(arg: Destination): arg is Category {
  return arg instanceof Category;
}

export class Category extends NamedResource implements Destination<Category> {
  private _lang: string;
  private _langMap = LANGUAGE_I18N_2_THEME;
  readonly type = 'category';
  readonly icon = DESTINATION_ICONS.category;
  warning: string[] = [];
  description: string;
  subtitle: string;
  source: Source;

  constructor(json: CategoryIO, lang: string) {
    super();
    this._lang = lang;
    this._initCategory(json);
  }

  private _getLocale(json: CategoryIO): CategoryLanguage | undefined {
    return json.languages.find((val: CategoryLanguage) => val.language === this._langMap[this._lang]);
  }

  private _initCategory(json: CategoryIO): void {
    const locale = this._getLocale(json);
    this.id = json.id;
    this.name = locale?.label ?? 'No label';
    this.description = locale?.description ?? '';
    this.subtitle = locale?.subtitle ?? '';
    this.source = SOURCE[json.source];
  }

  setWarning(payload: string): void {
    if (!this.warning.includes(payload)) {
      this.warning.push(payload);
    }
  }

  clearWarning(): void {
    this.warning = [];
  }

  getFullName(): string {
    return this.name;
  }

  getCount(): string {
    return '';
  }

  clone(): Category {
    return new Category(this.toJson(), this._lang);
  }

  toJson(): CategoryIO {
    return {
      id: this.id ,
      source: this.source,
      languages: [
        {language: this._langMap[this._lang], label: this.name, description: this.description, subtitle: this.subtitle}
      ]
    };
  }
}
